const DEBUG = false

export const navigations = [
    {
        name: 'Dashboard',
        path: '/',
        icon: 'dashboard',
    },
    {
        label: 'PAGES',
        type: 'label',
    },
    {
        name: 'Tools',
        icon: 'handyman',
        children: [
            {
                name: 'Technical Document Creator',
                iconText: 'SI',
                path: '/tools/tdoc-creator',
            },
            {
                name: 'Letter Creator',
                iconText: 'SI',
                path: '/tools/letter-creator',
            },
            {
                name: 'Proforma Creator',
                iconText: 'SI',
                path: '/tools/proforma-creator',
            },
            {
                name: 'Packing List Creator',
                iconText: 'SI',
                path: '/tools/packing-list-creator',
            },
        ],
    },
    {
        name: 'Service',
        icon: 'build',
        children: [
            {
                name: 'Product List',
                iconText: 'SI',
                path: '/service/product-list',
            },
            {
                name: 'Client List',
                iconText: 'SI',
                path: '/service/client-list',
            },
            {
                name: 'Field List',
                iconText: 'SI',
                path: '/service/field-list',
            },
            {
                name: 'System List',
                iconText: 'SI',
                path: '/service/system-list',
            },
            {
                name: 'Claim List',
                iconText: 'SI',
                path: '/service/claim-list',
            },
            {
                name: 'Contract List',
                iconText: 'SI',
                path: '/service/contract-list',
            },
            {
                name: 'Visit List',
                iconText: 'SI',
                path: '/service/visit-list',
            },
            {
                name: 'Report Create',
                iconText: 'SI',
                path: '/service/report-create',
            },
        ],
    },
    // {
    //     name: 'Session/Auth',
    //     icon: 'security',
    //     children: [
    //         {
    //             name: 'Sign in',
    //             iconText: 'SI',
    //             path: '/session/signin',
    //         },
    //         {
    //             name: 'Sign up',
    //             iconText: 'SU',
    //             path: '/session/signup',
    //         },
    //         {
    //             name: 'Forgot Password',
    //             iconText: 'FP',
    //             path: '/session/forgot-password',
    //         },
    //         {
    //             name: 'Error',
    //             iconText: '404',
    //             path: '/session/404',
    //         },
    //     ],
    // },
    // {
    //     label: 'Components',
    //     type: 'label',
    // },
    // {
    //     name: 'Components',
    //     icon: 'favorite',
    //     badge: { value: '30+', color: 'secondary' },
    //     children: [
    //         {
    //             name: 'Auto Complete',
    //             path: '/material/autocomplete',
    //             iconText: 'A',
    //         },
    //         {
    //             name: 'Buttons',
    //             path: '/material/buttons',
    //             iconText: 'B',
    //         },
    //         {
    //             name: 'Checkbox',
    //             path: '/material/checkbox',
    //             iconText: 'C',
    //         },
    //         {
    //             name: 'Dialog',
    //             path: '/material/dialog',
    //             iconText: 'D',
    //         },
    //         {
    //             name: 'Expansion Panel',
    //             path: '/material/expansion-panel',
    //             iconText: 'E',
    //         },
    //         {
    //             name: 'Form',
    //             path: '/material/form',
    //             iconText: 'F',
    //         },
    //         {
    //             name: 'Icons',
    //             path: '/material/icons',
    //             iconText: 'I',
    //         },
    //         {
    //             name: 'Menu',
    //             path: '/material/menu',
    //             iconText: 'M',
    //         },
    //         {
    //             name: 'Progress',
    //             path: '/material/progress',
    //             iconText: 'P',
    //         },
    //         {
    //             name: 'Radio',
    //             path: '/material/radio',
    //             iconText: 'R',
    //         },
    //         {
    //             name: 'Switch',
    //             path: '/material/switch',
    //             iconText: 'S',
    //         },
    //         {
    //             name: 'Slider',
    //             path: '/material/slider',
    //             iconText: 'S',
    //         },
    //         {
    //             name: 'Snackbar',
    //             path: '/material/snackbar',
    //             iconText: 'S',
    //         },
    //         {
    //             name: 'Table',
    //             path: '/material/table',
    //             iconText: 'T',
    //         },
    //     ],
    // },
    // {
    //     name: 'Charts',
    //     icon: 'trending_up',

    //     children: [
    //         {
    //             name: 'Echarts',
    //             path: '/charts/echarts',
    //             iconText: 'E',
    //         },
    //     ],
    // },
    // {
    //     name: 'Documentation',
    //     icon: 'launch',
    //     type: 'extLink',
    //     path: 'http://demos.ui-lib.com/matx-react-doc/',
    // },
]

export const demo_navigations = [
    {
        name: 'Dashboard',
        path: '/',
        icon: 'dashboard',
    },
    {
        label: 'PAGES',
        type: 'label',
    },
    {
        name: 'Tools',
        icon: 'handyman',
        children: [
            {
                name: 'Technical Document Creator',
                iconText: 'SI',
                path: '/tools/tdoc-creator',
            },
        ],
    },
]
